var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-cross"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icongraphic",
    d: "M89.545,15.292l-76,76c-0.977,0.977-2.256,1.465-3.536,1.465s-2.559-0.488-3.536-1.465 c-1.953-1.952-1.953-5.118,0-7.07l34.465-34.465L6.474,15.292c-1.953-1.953-1.953-5.119,0-7.071c1.954-1.952,5.119-1.951,7.071,0 L48.01,42.686L82.475,8.221c1.951-1.952,5.119-1.952,7.07,0C91.498,10.173,91.498,13.339,89.545,15.292z M60.982,55.659l-7.07,7.07 l28.562,28.562c0.976,0.977,2.256,1.465,3.535,1.465s2.56-0.488,3.535-1.465c0.977-0.976,1.465-2.256,1.465-3.535 s-0.488-2.56-1.465-3.535L60.982,55.659z",
    fill: "#ff0000"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.0d593f2b30659563d34efd65a3d505f5.svg";
export { ForwardRef as ReactComponent };